import { memo } from 'react'

import { AttachFile } from 'clickNgo/components/attachFile/AttachFile'
import { ACCEPTABLE_FILE_TYPES } from 'clickNgo/entities/partner/configs/files'
import { FieldGroup } from 'shared/components/fieldGroup'

import { IPartnerAttachmentsProps } from './models'
import { partnerAttachmentsTranslation } from './translation'

import styles from './PartnerAttachments.module.scss'

export const PartnerAttachments = memo<IPartnerAttachmentsProps>(
  ({
    formKeys,
    attachments,
    onAttachmentsValidate,
    isDisabled,
    isDisabledByRegion,
    isReadOnly,
    isVisible,
  }) => {
    return (
      <div className={styles.container}>
        <FieldGroup
          title={partnerAttachmentsTranslation.content.blockTitles.attachmentsBlock}
          size={1}
        >
          <AttachFile
            onValidate={onAttachmentsValidate}
            formKey={formKeys.attachments}
            attachments={attachments}
            isDisabled={isDisabled || isDisabledByRegion || isReadOnly}
            isVisible={isVisible}
            acceptedFormats={ACCEPTABLE_FILE_TYPES}
          />
        </FieldGroup>
      </div>
    )
  }
)
